import React from 'react';
import { Button, useTheme } from '@mui/material';
import { myButtonStyles } from './MyButton.styles';

const MyButton = ({
  children,
  variant = 'contained',
  color = 'primary',
  size = 'medium',
  fullWidth = false,
  disabled = false,
  onClick,
  startIcon,
  endIcon,
  customVariant,
  ...props
}) => {
  const theme = useTheme();

  return (
    <Button
      variant={variant}
      color={color}
      size={size}
      fullWidth={fullWidth}
      disabled={disabled}
      onClick={onClick}
      startIcon={startIcon}
      endIcon={endIcon}
      sx={myButtonStyles(theme, variant, customVariant)}
      {...props}
    >
      {children}
    </Button>
  );
};

export default MyButton;
